/**
 * Best EMI Card Service
 * Migrated from 3in1cms legacy/bestEMICardApi.ts
 */

import { request } from "../core/request";
import { DEFAULT_CONNECTION_FROM, OPERATION_IDS } from "./constants";
import { createErrorResponse } from "@repo/shared-utils/error-response";
import type { IBestEMICardResponse } from "../types/bestEMICardTypes";

/**
 * Fetch best EMI card details for customer
 * @returns Best EMI card response
 */
export const bestEMICardApi = async (mobileNumber: string): Promise<IBestEMICardResponse> => {
  try {
    const response = (await request<IBestEMICardResponse, { mobileNumber: string }>({
      operationId: OPERATION_IDS.bestEMICard,
      requestData: { mobileNumber },
      connectionFrom: DEFAULT_CONNECTION_FROM,
    })) as IBestEMICardResponse;
    return response;
  } catch (error) {
    return createErrorResponse<IBestEMICardResponse>(
      {
        CustomerSearchResponse: {
          CUSTINFO: [],
          RESDTT: "",
          RESPDESC: "",
          RSPCODE: "",
          RRN: "",
        },
        CardDetails: [],
      },
      "Error fetching Best EMI Card data"
    );
  }
};
